import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            leads: [],
            unreadCount: 0,
            pages: {},
            current: {}
        };
    },

    mutations: {
        setLeads(state, data) {
            state.leads = data;
        },
        setUnread(state, data) {
            state.unreadCount = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setCurrent(state, data) {
            state.current = data;
        },
        clearStore(state) {
            state.leads = {};
            state.current = {};
            state.pages = {};
        }
    },
    actions: {
        loadList({ state, commit }) {
            return new Promise((resolve, reject) => {
                api.get('/lead/').then(response => {
                    commit('setLeads', response.data.data.leads);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/lead/?' + qs.stringify(params)).then(response => {
                    commit('setLeads', response.data.data.leads);
                    commit('setUnread', response.data.data.count);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        getLead({ state, commit }, leadId) {
            return new Promise((resolve, reject) => {
                api.get('/lead/' + leadId).then(
                    response => {
                        commit('setCurrent', response.data.data);
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        updateLead(context, data) {
            return new Promise((resolve, reject) => {
                api.put('/lead/' + data.id, data).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        setTarget(context, data) {
            return new Promise((resolve, reject) => {
                api.put('/lead/target/' + data.id, data).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        createLead(context, data) {
            return new Promise((resolve, reject) => {
                api.post('/lead/', data).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        async getLeadsExportedToExcel({ state, commit }, params) {
            try {
                api.defaults.responseType = 'blob';
                return await api.get(`/lead/export/?${qs.stringify(params)}`);
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            } finally {
                api.defaults.responseType = '';
            }
        }
    },
    getters: {}

};

export default store;
